module.exports = __webpack_public_path__ + "static/media/right-direction-img.05ce06e3.svg";